import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteGoogleCalendarIntegration(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const mutationFn = (googleCalendarIntegration: string): Promise<AxiosResponse<null>> => {
    return client.delete(`google-calendar-integrations/${googleCalendarIntegration}/`);
  };

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries('google-calendar-integrations');
    },
  });
}
